import { IKey } from '../../../shared/types/interfaces/keyboard';

export const Keys: IKey = {
  ArrowDown: 'DOWN',
  ArrowLeft: 'LEFT',
  ArrowRight: 'RIGHT',
  ArrowUp: 'UP',
  Enter: 'SELECT',
  MediaPause: 'PAUSE',
  MediaPlay: 'PLAY',
  MediaStop: 'STOP',
  XF86Back: 'BACK',
  XF86NextChapter: 'NEXT',
  XF86PreviousChapter: 'PREVIOUS',
  XF86LowerChannel: 'CHANNEL_DOWN',
  XF86RaiseChannel: 'CHANNEL_UP',
  XF86AudioNext: 'FASTFORWARD',
  XF86AudioRewind: 'REWIND',
  XF86AudioPause: 'PAUSE',
  XF86AudioPlay: 'PLAY',
  0: 'ZERO',
  1: 'ONE',
  2: 'TWO',
  3: 'THREE',
  4: 'FOUR',
  5: 'FIVE',
  6: 'SIX',
  7: 'SEVEN',
  8: 'EIGHT',
  9: 'NINE',
  13: 'SELECT',
  19: 'PAUSE',
  37: 'LEFT',
  38: 'UP',
  39: 'RIGHT',
  40: 'DOWN',
  48: 'ZERO',
  49: 'ONE',
  50: 'TWO',
  51: 'THREE',
  52: 'FOUR',
  53: 'FIVE',
  54: 'SIX',
  55: 'SEVEN',
  56: 'EIGHT',
  57: 'NINE',
  412: 'REWIND',
  413: 'STOP',
  415: 'PLAY',
  417: 'FASTFORWARD',
  428: 'CHANNEL_DOWN',
  427: 'CHANNEL_UP',
  10009: 'BACK',
};
